/**
 * @param {Asset[]} assets
 * @returns {number}
 */
function calcProjectDuration(assets, { skipEmptySpace }) {
  let totalDuration = 0
  for (const asset of assets) {
    totalDuration = Math.max(totalDuration, asset.endTime)
  }
  return totalDuration - (skipEmptySpace ? (assets[0]?.startTime ?? 0) : 0)
}

export default calcProjectDuration
